import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface UserByProfileIdResponse {
  id: string
  accessLevel: string
  emailAddress: string
  firstName?: string
  lastName?: string
  profileId?: string
  profile?: {
    id: string
    role: string
    firstName: string
    lastName: string
    emailAddress: string
    status: string
    createdAt?: string
  }
  createdAt?: string
}

export const useUserByProfileId = (profileId?: string) => {
  const fetchWithAuth = useFetchWithAuth()

  const getUserByProfileId: QueryFunction<UserByProfileIdResponse> = async () => {
    if (!profileId) {
      throw new Error('Profile ID is required')
    }

    try {
      const responseData = await fetchWithAuth(
        `${URL}/roles/user-by-profile/${profileId}`,
        {
          method: 'GET',
        }
      )
      return responseData
    } catch (error) {
      console.error('Error fetching user by profile ID:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['userByProfileId', profileId] as const,
    queryFn: getUserByProfileId,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!profileId && profileId.length > 0,
  })
}
